import { GuideMainTopics } from '@app/components/Guide/types/guide.types'
import { useParams } from 'react-router-dom'
import { DemoPage } from './DemoPage'
import ArticlePage from './ArticlePage'
import { TutorialPage } from './TutorialPage'

export const GuideContentPage = () => {
  const { mainTopic } = useParams()

  switch (mainTopic) {
    case GuideMainTopics.DEMOS:
      return <DemoPage />

    case GuideMainTopics.TUTORIALS:
      return <TutorialPage />

    default:
      return <ArticlePage />
      break
  }
}
